var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("用户管理")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "平台用户", prop: "platformId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "215px" },
                        attrs: {
                          placeholder: "请选择平台用户",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "platformId", $$v)
                          },
                          expression: "searchForm.platformId",
                        },
                      },
                      _vm._l(_vm.platformList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户ID", prop: "userId" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { placeholder: "请输入用户ID", clearable: "" },
                      model: {
                        value: _vm.searchForm.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "userId", $$v)
                        },
                        expression: "searchForm.userId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户昵称", prop: "username" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { placeholder: "请输入用户昵称" },
                      model: {
                        value: _vm.searchForm.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "username", $$v)
                        },
                        expression: "searchForm.username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码", prop: "goodsNo" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { placeholder: "请输入手机号码" },
                      model: {
                        value: _vm.searchForm.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "phone", $$v)
                        },
                        expression: "searchForm.phone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否购买商品", prop: "brandId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "215px" },
                        attrs: {
                          placeholder: "请选择",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.hasShopping,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "hasShopping", $$v)
                          },
                          expression: "searchForm.hasShopping",
                        },
                      },
                      _vm._l(_vm.hasShoppings, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "加入时间", prop: "brandId" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.joinTime,
                        callback: function ($$v) {
                          _vm.joinTime = $$v
                        },
                        expression: "joinTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "最近访问时间", prop: "brandId" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.lastActiveTime,
                        callback: function ($$v) {
                          _vm.lastActiveTime = $$v
                        },
                        expression: "lastActiveTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _c("h3", [_vm._v("列表数据")]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deriveDeliver },
                },
                [_vm._v("批量导出")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.page.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }